export const isTodayInMonth = (currentDate, day) => {
    const today = new Date();

    return (
        currentDate.getFullYear() === today.getFullYear() &&
        currentDate.getMonth() === today.getMonth() &&
        Number(day) === today.getDate()
    );
};
